import Avi from './Avi';

document.addEventListener('DOMContentLoaded', () => {
  const aviElements = document.querySelectorAll('.js-avi');
  if (!aviElements.length) {
    return;
  }

  aviElements.forEach((element) => {
    const avi = new Avi(element);
    avi.mount(element);
  });
});
